import React from 'react';
import { Accordion } from 'react-bootstrap';
import FullProduct from './Sections/FullProduct';
import './ProductImages.scss';
import CloseUp from './Sections/CloseUp';
import OtherReferences from './Sections/OtherReferences';

function ProductImages() {
  return (
    <div className="request-images-wrapper">
      <Accordion className="request-accordion-wrapper" flush>
        <Accordion.Item eventKey="0">
          <Accordion.Header>Full Product</Accordion.Header>
          <Accordion.Body>
            <FullProduct className="no-pointer-event" isReadOnly />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>Close-up</Accordion.Header>
          <Accordion.Body>
            <CloseUp className="no-pointer-event" isReadOnly />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header>Other References</Accordion.Header>
          <Accordion.Body>
            <OtherReferences className="no-pointer-event" isReadOnly />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

export default ProductImages;
